// @fow
import MapConfigContainer from './containers/MapConfigContainer';

export default MapConfigContainer;